"use strict";
exports.__esModule = true;
var react_1 = require("react");
var useOnDidUpdate = function (callback, conditions) {
    var didMountRef = react_1.useRef(false);
    react_1.useEffect(function () {
        if (didMountRef.current) {
            callback();
        }
        else {
            didMountRef.current = true;
        }
    }, conditions);
};
exports["default"] = useOnDidUpdate;
//# sourceMappingURL=useOnDidUpdate.js.map